import React, { useState, useEffect, useCallback } from "react";
import api from "../api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Loader2, Activity, RefreshCw } from "lucide-react";

const fmtDt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export default function ActivityLog() {
  const [users, setUsers] = useState([]);
  const [uid, setUid] = useState("all");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/admin/users").then(({ data }) => setUsers(data.users || [])).catch(() => {});
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/activity?uid=${uid}&limit=200`);
      setRows(data.activity || []);
    } catch { /* noop */ }
    finally { setLoading(false); }
  }, [uid]);
  useEffect(() => { load(); }, [load]);

  return (
    <section data-testid="activity-log">
      <div className="flex items-center gap-2 mb-1">
        <Activity className="h-5 w-5 text-[#1a5f5a]" />
        <h3 className="font-display font-semibold text-lg">Registro attività</h3>
      </div>
      <p className="text-xs text-slate-400 mb-4">Cronologia delle azioni degli operatori (accessi, preventivi, AI, impostazioni, gestione utenti). Le voci vengono conservate per 90 giorni.</p>

      <div className="flex items-center gap-3 mb-4">
        <Select value={uid} onValueChange={setUid}>
          <SelectTrigger className="w-72" data-testid="activity-user-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tutti gli utenti</SelectItem>
            {users.map((u) => <SelectItem key={u.id} value={u.id} data-testid={`activity-filter-${u.email}`}>{u.email}</SelectItem>)}
          </SelectContent>
        </Select>
        <button onClick={load} className="text-sm text-slate-500 hover:text-slate-700 flex items-center gap-1.5" data-testid="activity-refresh">
          <RefreshCw className="h-3.5 w-3.5" /> Aggiorna
        </button>
      </div>

      {loading ? (
        <div className="py-6 text-center text-slate-400"><Loader2 className="h-5 w-5 animate-spin inline" /></div>
      ) : rows.length === 0 ? (
        <div className="py-6 text-center text-slate-400 text-sm" data-testid="activity-empty">Nessuna attività registrata.</div>
      ) : (
        <div className="border border-slate-200 rounded-md divide-y divide-slate-100" data-testid="activity-list">
          {rows.map((r) => (
            <div key={r.id} className="flex items-center justify-between gap-3 px-3 py-2 text-sm">
              <div className="min-w-0 truncate">
                <span className="text-slate-800">{r.action}</span>
                {uid === "all" && <span className="text-slate-400"> · {r.user_email}</span>}
                {r.detail ? <span className="text-slate-400"> — {r.detail}</span> : null}
              </div>
              <span className="text-xs text-slate-400 whitespace-nowrap">{fmtDt(r.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
